import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "constants/queryKeys";
import { errorModal } from "modules/error/ErrorHandlingModals";
import { ErrorResponse } from "types";

import { getQuestionnaireListService, TGetQuestionnaireListServiceArgs } from "../api";

export const useGetQuestionnaireListQuery = ({ accountId, apiParams }: TGetQuestionnaireListServiceArgs) =>
  useQuery({
    queryKey: [QUERY_KEYS.get_questionnaire_list],
    queryFn: () => getQuestionnaireListService({ accountId, apiParams }),
    useErrorBoundary: true,
    onError: (error: ErrorResponse) => errorModal(error),
    enabled: !!accountId
  });
